import React from 'react';

import Responsive from '@/components/Responsive';

import PasswordWithTooltipDesktop from './index.desktop';
import PasswordWithTooltipMobile from './index.mobile';
import { PasswordWithTooltipProps } from './types';

const PasswordWithTooltip = (props: PasswordWithTooltipProps) => {
  return (
    <Responsive>
      <Responsive.Default>
        <PasswordWithTooltipMobile {...props} />
      </Responsive.Default>
      <Responsive.Desktop>
        <PasswordWithTooltipDesktop {...props} />
      </Responsive.Desktop>
    </Responsive>
  );
};

export default React.memo(PasswordWithTooltip);
